import VPageVoucherAddRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageVoucherAddRecord', VPageVoucherAddRecord),
};
